module.exports = __webpack_public_path__ + "static/scene-a132de497846b0b6c97cef51195b0a3d.svg";